<template>
  <div class="common-view content-view">
    <common-header/>

    <div class="container" v-if="reportings !== null">
      <h1 class="main-title">Users</h1>

      <div class="panels">
        <div class="panel">
          <div class="inner charts">

            <div class="chart">
              <chart :options="barOptions" ref="barCharts" class="bar-chart"></chart>
            </div>

            <div class="items">

              <div class="item">
                <div class="title">All users</div>

                <div class="value">{{reportings['total-user'].total}}</div>

                <div :class="reportings['total-user'].loss > 0 ? 'hint red' : 'hint green'">
                  {{reportings['total-user'].loss > 0 ? `-${reportings['total-user'].loss}` : `+${reportings['total-user'].gain}`}}
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <div class="panels">

        <div class="panel">
          <div class="inner">

            <h2 class="block-title">
              <span class="status yellow"></span>
              <span class="text">TRIAL USERS</span>
            </h2>

            <div class="items">

              <div class="item">
                <div class="title">Active</div>

                <div class="value">{{reportings['trial-active'].total}}</div>

                <div :class="reportings['trial-active'].loss > 0 ? 'hint red' : 'hint green'">
                  {{reportings['trial-active'].loss > 0 ? `-${reportings['trial-active'].loss}` : `+${reportings['trial-active'].gain}`}}
                </div>
              </div>

              <div class="item">
                <div class="title">Inactive</div>

                <div class="value">{{reportings['trial-inactive'].total}}</div>

                <div :class="reportings['trial-inactive'].loss > 0 ? 'hint red' : 'hint green'">
                  {{reportings['trial-inactive'].loss > 0 ? `-${reportings['trial-inactive'].loss}` : `+${reportings['trial-inactive'].gain}`}}
                </div>
              </div>

            </div>

          </div>
        </div>

        <div class="panel">
          <div class="inner">

            <h2 class="block-title">
              <span class="status green"></span>
              <span class="text">PAID USERS</span>
            </h2>

            <div class="items">

              <div class="item">
                <div class="title">Active</div>

                <div class="value">{{reportings['paid-active'].total}}</div>

                <div :class="reportings['paid-active'].loss > 0 ? 'hint red' : 'hint green'">
                  {{reportings['paid-active'].loss > 0 ? `-${reportings['paid-active'].loss}` : `+${reportings['paid-active'].gain}`}}
                </div>
              </div>

              <div class="item">
                <div class="title">Inactive</div>

                <div class="value">{{reportings['paid-inactive'].total}}</div>

                <div :class="reportings['paid-inactive'].loss > 0 ? 'hint red' : 'hint green'">
                  {{reportings['paid-inactive'].loss > 0 ? `-${reportings['paid-inactive'].loss}` : `+${reportings['paid-inactive'].gain}`}}
                </div>
              </div>

            </div>

          </div>
        </div>

      </div>

      <div class="panels">

        <div class="panel">
          <div class="inner">

            <h2 class="block-title">
              <span class="status blue"></span>
              <span class="text">TEAM USERS</span>
            </h2>

            <div class="items">

              <div class="item">
                <div class="title">Active</div>

                <div class="value">{{reportings['teams-active'].total}}</div>

                <div :class="reportings['teams-active'].loss > 0 ? 'hint red' : 'hint green'">
                  {{reportings['teams-active'].loss > 0 ? `-${reportings['teams-active'].loss}` : `+${reportings['teams-active'].gain}`}}
                </div>
              </div>

              <div class="item">
                <div class="title">Inactive</div>

                <div class="value">{{reportings['teams-inactive'].total}}</div>

                <div :class="reportings['teams-inactive'].loss > 0 ? 'hint red' : 'hint green'">
                  {{reportings['teams-inactive'].loss > 0 ? `-${reportings['teams-inactive'].loss}` : `+${reportings['teams-inactive'].gain}`}}
                </div>
              </div>

            </div>

          </div>
        </div>

        <div class="panel">

          <div class="panels">

            <div class="panel">
              <div class="inner">

                <h2 class="block-title">
                  <span class="status gray"></span>
                  <span class="text">OVERRIDES</span>
                </h2>

                <div class="items">

                  <div class="item">
                    <div class="title">Active</div>

                    <div class="value">{{reportings['override-1-month'].total + reportings['override-3-month'].total + reportings['override-forever'].total}}</div>

                    <div :class="reportings['override-1-month'].loss + reportings['override-3-month'].loss + reportings['override-forever'].loss > 0 ? 'hint red' : 'hint green'">
                      {{reportings['override-1-month'].loss + reportings['override-3-month'].loss + reportings['override-forever'].loss > 0 ? `-${reportings['override-1-month'].loss + reportings['override-3-month'].loss + reportings['override-forever'].loss}` : `+${reportings['override-1-month'].gain + reportings['override-3-month'].gain + reportings['override-forever'].gain}`}}
                    </div>
                  </div>

                </div>

              </div>
            </div>

            <div class="panel">
              <div class="inner">

                <h2 class="block-title">
                  <span class="text">DISTRIBUTION</span>
                </h2>

                <chart :options="pieOptions" ref="pieCharts" class="pie-chart"></chart>

              </div>
            </div>

          </div>

        </div>

      </div>

      <div class="filter form">

        <div class="row">
          <div class="group">
            <input type="search" class="control" placeholder="Search" v-model="searchEmail"/>
          </div>

          <div class="group">
            <div class="select-dropdown" :class="{active: open === 2}" ref="type">
              <div class="current" @click="toggle(2)" :class="{placeholder: type.placeholder}">
              <span class="text">
                {{ !type.placeholder ? type.text : 'Account Status Type' }}
              </span>
                <i class="material-icons">keyboard_arrow_down</i>
              </div>

              <color-dropdown :items="typeItems" :onSelect="handleType" :hideColor="true"/>
            </div>
          </div>
        </div>

      </div>

      <table class="table">
        <thead>
        <tr>
          <th>USERS ({{reportings['total-user'].total}})</th>
          <th class="text-center hidden-phone">JOIN DATE</th>
          <th class="text-center">STATUS</th>
          <th class="text-center hidden-phone">PALETTES</th>
          <th class="text-center hidden-phone">UI</th>
          <!-- <th class="text-center hidden-phone">STARTER KITS</th> -->
        </tr>
        </thead>
        <tbody v-if="curUsers !== null">
        <metric-user
          v-for="(user, index) in curUsers"
          :key="index"
          status="gray"
          :onEdit="() => togglePayment(index)"
          :user="user"
        />
        </tbody>
      </table>

      <a class="btn medium default" @click="onLoadMore" v-if="isLoadMore">Load 100 more</a>
    </div>

    <div class="modal-payment popup-wrapper" :class="{active: showPayment}">
      <div class="bg" @click="() => togglePayment()"></div>

      <div class="popup">
        <div class="close" @click="() => togglePayment()">
          <i class="material-icons">close</i>
        </div>

        <div class="container">
          <h1 class="main-title">Payment override</h1>

          <form class="form" @submit.prevent="() => togglePayment()">
            <div class="label">Choose type</div>

            <div class="select-dropdown" :class="{active: open === 1}" ref="payment">
              <div class="current" @click="toggle(1)" :class="{placeholder: payment.placeholder}">
              <span class="text">
                {{ !payment.placeholder ? payment.text : 'Select override' }}
              </span>
                <i class="material-icons">keyboard_arrow_down</i>
              </div>

              <color-dropdown :items="paymentItems" :onSelect="handlePayment" :hideColor="true"/>
            </div>

            <button type="submit" class="btn primary medium" @click="onChangePayment">Save</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { Chart } from 'highcharts-vue';
import { findAncestor } from '../utils/helper';
import ColorDropdown from '../components/color/ColorDropdown';
import CommonHeader from './CommonHeader';
import MetricUser from '../components/metric/MetricUser';
import { getSession } from '../utils/session';
import { sendRequest } from '../utils/api';

export default {
  components: {
    Chart,
    ColorDropdown,
    MetricUser,
    CommonHeader,
  },
  data() {
    return {
      searchEmail: '',
      isLoadMore: true,
      countByIndex: 0,
      users: null,
      curUsers: null,
      reportings: null,
      showPayment: false,
      open: 0,
      type: {
        placeholder: true,
      },
      typeItems: [
        {
          placeholder: true,
          text: 'Any status',
        },
        {
          text: 'trial-active',
        },
        {
          text: 'trial-inactive',
        },
        {
          text: 'paid-active',
        },
        {
          text: 'paid-inactive',
        },
        {
          text: 'team-member-active',
        },
        {
          text: 'team-member-inactive',
        },
        {
          text: 'team-manager-active',
        },
        {
          text: 'team-manager-inactive',
        },
        {
          text: 'override-1-month',
        },
        {
          text: 'override-2-month',
        },
        {
          text: 'override-3-month',
        },
      ],
      payment: {
        placeholder: true,
      },
      paymentItems: [
        {
          placeholder: true,
          text: 'None',
        },
        {
          text: '1 month',
        },
        {
          text: '3 months',
        },
        {
          text: 'Forever',
        },
      ],
      barOptions: {
        chart: {
          backgroundColor: '#F7F7F7',
          borderColor: '#F7F7F7',
        },
        title: {
          text: '',
        },
        xAxis: {
          // visible: false,
          categories: ['Mon', 'Tue'],
        },
        yAxis: {
          visible: false,
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '{point.y}',
        },
        series: [{
          type: 'column',
          colorByPoint: true,
          data: [29.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5],
          showInLegend: false,
        }],
        colors: ['#b5b5b5'],
        plotOptions: {
          column: {
            states: {
              hover: {
                color: '#525252',
              },
            },
          },
        },
      },
      pieOptions: {
        chart: {
          type: 'pie',
          backgroundColor: '#F7F7F7',
          borderColor: '#F7F7F7',
          margin: [0, 0, 0, 0],
          spacingTop: 0,
          spacingBottom: 0,
          spacingLeft: 0,
          spacingRight: 0,
        },
        title: {
          text: '',
        },
        xAxis: {
          visible: false,
        },
        yAxis: {
          visible: false,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            shadow: false,
          },
        },
        tooltip: {
          formatter() {
            return `<b>${this.point.name}</b>: ${this.y}`;
          },
        },
        series: [{
          name: 'Browsers',
          data: [['AA', 6], ['BB', 4], ['CC', 7], ['DD', 7]],
          size: '100%',
          innerSize: '70%',
          showInLegend: true,
          dataLabels: {
            enabled: false,
          },
        }],
        selectedUser: -1,
        colors: ['#2284EB', '#53C37A', '#C1C1C1', '#FFC800'],
      },
    };
  },
  created() {
    document.addEventListener('click', this.clickEvent);
    sendRequest('/users/number_of_users', 'get', { Authorization: getSession('jwtoken') }, {})
      .then((responseNumberOfUsers) => {
        this.barOptions.xAxis.categories = responseNumberOfUsers.data.reportings
          .map(reporting => reporting.date);
        this.barOptions.series[0].data = responseNumberOfUsers.data.reportings
          .map(reporting => reporting.users);
        sendRequest('/reportings/all', 'get', { Authorization: getSession('jwtoken') }, {})
          .then((response) => {
            this.reportings = response.data.reportings;
            this.pieOptions.series[0].data = [
              ['Teams', this.reportings['teams-active'].total + this.reportings['teams-inactive'].total],
              ['Paid', this.reportings['paid-active'].total + this.reportings['paid-inactive'].total],
              ['Override', this.reportings['override-1-month'].total + this.reportings['override-3-month'].total
                  + this.reportings['override-forever'].total,
              ],
              ['Trial', this.reportings['trial-active'].total + this.reportings['trial-inactive'].total],
            ];

            sendRequest(`/users/all?count=${100}&start=${100 * this.countByIndex}`, 'get', { Authorization: getSession('jwtoken') }, {})
              .then((usersResponse) => {
                this.users = usersResponse.data.users;
                this.curUsers = this.users;
              })
              .catch(err => console.log(err));
          })
          .catch(err => console.log(err));
      })
      .catch(err => console.log(err));
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickEvent);
  },
  methods: {
    ...mapActions('notification', [
      'addNotification',
    ]),
    handleFilter() {
      this.curUsers = this.users.filter(user => user.email.includes(this.searchEmail));
      if (this.type.placeholder) {
        return;
      }

      let accessType = '';
      let isTeamMember = false;
      let isTeamManager = false;
      switch (this.type.text) {
        case 'trial-active':
          accessType = 'trial';
          break;
        case 'trial-inactive':
          accessType = 'trial-inactive';
          break;
        case 'paid-active':
          accessType = 'paid';
          break;
        case 'paid-inactive':
          accessType = 'paid-inactive';
          break;
        case 'team-member-active':
          isTeamMember = true;
          isTeamManager = false;
          accessType = 'active';
          break;
        case 'team-member-inactive':
          isTeamMember = true;
          isTeamManager = false;
          accessType = 'inactive';
          break;
        case 'team-manager-active':
          isTeamMember = true;
          isTeamManager = true;
          accessType = 'active';
          break;
        case 'team-manager-inactive':
          isTeamMember = true;
          isTeamManager = true;
          accessType = 'inactive';
          break;
        case 'override-1-month':
          accessType = 'override-1-month';
          break;
        case 'override-3-month':
          accessType = 'override-3-month';
          break;
        case 'override-forever':
          accessType = 'override-forever';
          break;
        default:
          break;
      }
      this.curUsers = this.curUsers.filter(user => (isTeamMember ? (isTeamManager ? user['access-type'] === 'team-manager' : user['access-type'] === 'team-member') && user['team-status'] === accessType : user['access-type'] === accessType));
    },
    onLoadMore() {
      this.countByIndex = this.countByIndex + 1;

      sendRequest(`/users/all?count=100&start=${100 * this.countByIndex}`, 'get', { Authorization: getSession('jwtoken') }, {})
        .then((usersResponse) => {
          if (usersResponse.data.users.length === 0) {
            this.isLoadMore = false;
          } else {
            this.users.concat(usersResponse.data.users);
            this.handleFilter();
          }
        })
        .catch(err => console.log(err));
    },
    onChangePayment() {
      if (this.selectedUser === -1) {
        return;
      }
      const currentUser = this.curUsers[this.selectedUser];
      const selected = this.selectedUser;
      let currentAccessType = 'NONE';

      switch (this.payment.text) {
        case '1 month':
          currentAccessType = 'override-1-month';
          break;
        case '3 months':
          currentAccessType = 'override-3-month';
          break;
        case 'Forever':
          currentAccessType = 'override-forever';
          break;
        default:
          break;
      }
      if (currentAccessType === 'NONE' || currentUser['access-type'] === this.payment.text) {
        return;
      }
      sendRequest(`/users/update_access/${currentUser['user-id']}`, 'put', { Authorization: getSession('jwtoken') }, {
        'access-type': currentAccessType,
      })
        .then(() => {
          this.curUsers[selected]['access-type'] = currentAccessType;
          this.curUsers = Object.assign({}, this.curUsers);
          this.addNotification({ message: 'Override status has been updated successfully!' });
        })
        .catch(err => console.log(err));
    },
    togglePayment(index) {
      if (index === undefined) {
        this.selectedUser = -1;
      } else {
        this.selectedUser = index;
      }
      this.showPayment = !this.showPayment;
    },
    toggle(id) {
      this.open = this.open === id ? 0 : id;
    },
    handlePayment(item) {
      this.open = 0;
      this.payment = item;
    },
    handleType(item) {
      this.open = 0;
      this.type = item;
      this.handleFilter();
    },
    clickEvent(e) {
      if (
        this.$refs.payment !== findAncestor(e.target, 'select-dropdown')
          && this.$refs.type !== findAncestor(e.target, 'select-dropdown')
      ) {
        this.open = 0;
      }
    },
  },
  watch: {
    searchEmail() {
      this.handleFilter();
    },
  },
};
</script>

<style lang="scss" scoped>
  .panels {
    margin: 0 -6px 20px;
    text-align: center;
    flex: 1;

    @include media($notMobile) {
      display: flex;
      flex-flow: row wrap;
    }

    .panels {
      @include media($notMobile) {
        margin-bottom: 0;
      }
    }
  }

  .panel {
    padding: 0 6px;
    flex: 1;

    @include media($notMobile) {
      display: flex;
    }
  }

  .inner {
    padding: 20px 0;
    box-shadow: 0 14px 19px rgba(black, .08);
    width: 100%;
  }

  .items {
    display: flex;
  }

  .item {
    flex: 1;

    @include media($mobile) {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .chart {
    background: $bg2;
    box-shadow: none;
    border: none;
    padding: 0;
    margin: 0;
  }

  .bar-chart {
    height: 200px;
  }

  .pie-chart {
    height: 100px;
  }

  .charts {
    @include media($notMobile) {
      display: flex;
      align-items: center;
    }

    .chart {
      flex: 3;

      @include media($mobile) {
        margin-bottom: 30px;
      }
    }

    .items {
      flex: 1;
    }
  }

  .block-title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 30px;

    .text {
      opacity: .3;
    }
  }

  .title {
    opacity: .5;
    margin-bottom: 10px;
  }

  .value {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .hint {
    font-size: 12px;
    font-weight: 500;
  }

  .filter {
    margin: 50px 0 30px;
  }

  .table {
    margin-bottom: 40px;
  }

  th {
    font-weight: bold;
    font-size: 14px;
    opacity: .3;

    &:first-child {
      text-align: left;
    }
  }

  .modal-payment {
    .container {
      max-width: 500px;
      margin: 0;
    }

    .select-dropdown {
      margin-bottom: 100px;
    }

    .label {
      margin-bottom: 15px;
    }
  }

  .status {
    width: 10px;
    height: 10px;
    border-radius: 100%;
    display: inline-block;
    margin-right: 10px;

    &.gray {
      background: $gray;
    }

    &.blue {
      background: $blue;
    }

    &.green {
      background: $green;
    }

    &.red {
      background: $red;
    }

    &.yellow {
      background: $yellow;
    }
  }
</style>
